import React from "react";
import { cn } from "@/utils/utils";

interface ToolbarButtonProps {
  isActive?: boolean;
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
}

const ToolbarButton = React.forwardRef<HTMLButtonElement, ToolbarButtonProps>(
  ({ isActive, onClick, children, className }, ref) => (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      className={cn(
        "flex items-center justify-center w-6 h-6 rounded transition-all duration-150",
        "text-secondary hover:bg-surface-hover-strong",
        isActive && "bg-surface-pressed text-primary",
        className
      )}
    >
      {children}
    </button>
  )
);
ToolbarButton.displayName = "ToolbarButton";

export default ToolbarButton;
